import { PORTALS } from "../../../utils/portalTypes";
import PortalLoginPage from "../Auth/PortalLoginPage";

export default function DoctorLogin() {
  return <PortalLoginPage portal={PORTALS.staff} />;
}
